import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  flex-direction: row;
  font-size: 12px;
  height: 15px;
`

const Percentage = props =>
  (
    <Container>
      {props.percentage &&
      <span style={{ color: '#3A73D6', marginRight: '5px' }}>{`${props.percentage}%`}</span>
      }
      {props.descriptor &&
      <span style={{ color: '#919EAB' }}>{props.descriptor}</span>
      }
    </Container>
  )

export default Percentage



// WEBPACK FOOTER //
// ./src/Components/ReportsComponents/Percentage.jsx